<template>
  <div>
    <h2 class="el_h2">设置个人资料</h2>
    <!-- 个人资料表单 -->
    <el-form
    ref="personal_form"
    :model="personal_form"
    label-width="80px"
    class="personal_form"
    :rules="rules_form"
    >
      <el-form-item label="用户名">
        <el-input :readonly="true" v-model="userName"></el-input>
      </el-form-item>
      <!-- <el-form-item label="用户组">
        <el-input :readonly="true"></el-input>
      </el-form-item> -->
      <el-form-item label="昵称" prop="nickName">
        <el-input v-model="personal_form.nickName"></el-input>
      </el-form-item>
      <el-form-item label="头像地址" prop="userPic">
        <el-upload
        action="#"
        list-type="picture-card"
        :auto-upload="false"
        :on-change="change_file"
        :on-preview="show_big"
        :on-remove="remove_file"
        :limit="1"
        ref="upload_file"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-radio v-model="personal_form.sex" :label="1">男</el-radio>
        <el-radio v-model="personal_form.sex" :label="0">女</el-radio>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="personal_form.email"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input type="number" v-model="personal_form.phone"></el-input>
      </el-form-item>
      <el-form-item label="QQ" prop="qq">
        <el-input type="number" v-model="personal_form.qq"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit_form()">提交</el-button>
        <el-button @click="reset_form()">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 查看大图 -->
    <el-dialog
    :append-to-body='true'
    :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl+'?auth_token='+upload_token" />
    </el-dialog>
  </div>
</template>

<script>
  import {isEmail,isPhone} from '../../../static/validate.js'
  export default {
    data() {
      let validateEmail =(rule, value, callback)=>{
        if(!isEmail(value)){
          callback(new Error('邮箱格式错误'))
        }else{
          callback()
        }
      }
      let validatePhone =(rule, value, callback)=>{
        if(!isPhone(value)){
          callback(new Error('手机号格式错误'))
        }else{
          callback()
        }
      }
      return{
        //用户名
        userName:localStorage.getItem('userName'),
        upload_token:localStorage.getItem(localStorage.getItem('userName')+'token'),
        //大图相关
        dialogVisible:false,
        dialogImageUrl:'',
        //个人资料表单
        personal_form:{
          nickName:localStorage.getItem('nickName'),
          userPic:'',
          sex:1,
          email:'',
          phone:'',
          qq:''
        },
        //表单验证
        rules_form:{
          nickName:[
            {required:true,message:'请输入昵称',trigger:'blur'}
          ],
          email:[
            {required:true,message:'请输入邮箱',trigger:'blur'},
            {validator:validateEmail,trigger:'blur'}
          ],
          phone:[
            {required:true,message:'请输入电话',trigger:'blur'},
            {validator:validatePhone,trigger:'blur'}
          ],
          qq:[
            {required:true,message:'请输入QQ号',trigger:'blur'}
          ]
        }
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //获取当前用户基础信息
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/user/base'
      }).then(data=>{
        if(data.data.success==true){
          that.personal_form.nickName=data.data.data.nickName
          that.personal_form.sex=data.data.data.sex
          that.personal_form.email=data.data.data.email
          that.personal_form.phone=data.data.data.phone
          that.personal_form.qq=data.data.data.qq
        }else{
          that.$message.error(data.data.message)
        }
      })
    },
    mounted() {

    },
    methods:{
      //查看大图
      show_big(file){
        this.dialogImageUrl=file.url
        this.dialogVisible=true
      },
      //添加图片
      change_file(file){
        this.personal_form.userPic=file.name
      },
      //移除图片
      remove_file(file){
        this.personal_form.userPic=''
      },
      //提交表单
      submit_form(){
       let that=this
        this.$refs['personal_form'].validate((valid)=>{
          if(valid){
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/user/base',
              data:that.personal_form,
              headers:{
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }else{
            return false
          }
        })
      },
      //重置表单
      reset_form(){
        this.$refs['personal_form'].resetFields()
        this.$refs['upload_file'].clearFiles()
      }
    }
  }
</script>

<style scoped="scoped">
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .personal_form{
    width: 60%;
  }
  @media screen and (max-width:720px) {
    .personal_form{
      width: 100%;
    }
  }
  /deep/
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/personal_data.vue